export enum DatiqAnalyticsInputInteraction {
    Add = 'add',
    Added = 'added',
    Check = 'checked',
    CheckRadio = 'checked__radio',
    Click = 'click',
    Close = 'close',
    Closed = 'closed',
    Deselected = 'deselected',
    Errored = 'errored',
    Hover = 'hover',
    KeyPressDelete = 'delete',
    KeyPressReturn = 'return',
    Load = 'load',
    Open = 'open',
    Raises = 'raises',
    Removed = 'removed',
    Search = 'search',
    Selected = 'selected',
    Uncheck = 'unchecked',
    UncheckRadio = 'unchecked__radio',
    Unknown = '',
    Updated = 'updated',
    Uploaded = 'uploaded'
}

export enum DatiqAnalyticsActionTypes {
    Track = 'track',
    Page = 'page',
    Identify = 'identify',
    Reset = 'rest',
    Unknown = '',
}

export enum DatiqAnalyticsApplicationMode {
    Demo = 'Demo',
    Freemium = 'Freemium',
    Paid = 'Paid',
    Unknown = '',
}

export enum DatiqAnalyticsInitiator {
    User = 'User',
    System = 'System',
    Unknown = '',
}

export enum DatiqAnalyticsTrackPropertiesKey {
    ApplicationMode = 'application_mode',
    ApplicationVersion = 'application_version',
    CsbUserId = 'csb_user_id',
    DatPrimaryApplication = 'dat_primary_application',
    Email = 'email',
    Initiator = 'initiator',
    InteractionGesture = 'interaction_gesture',
    Page = 'page',
    TrackingVersion = 'tracking_version',
    UiLabel = 'ui_label',
    UiLocation = 'ui_location',
    EventName = 'event_name',
}

export enum DatiqAnalyticsTrackingEventKeys {
    GlobalId = 'Global ID',
    PreImplementationStatus = 'Pre- Implementation Status',
    ChangeType = 'Change Type',
    Id = 'ID',
    Ticket = 'Ticket',
    Status = 'Status',
    Priority = 'Priority',
    Initiator = 'Initiator',
    EventName = 'Event Name',
    Page = 'Page',
    Location = 'Location',
    TrackingType = 'Tracking Type',
    SpecificProperties = 'Specific Properties',
}

export enum DatiqAnalyticsPropsIdentifyKeys {
    ApplicationMode = 'application_mode',
    ApplicationVersion = 'application_version',
    CsbUserId = 'csb_user_id',
    DatPrimaryApplication = 'dat_primary_application',
    Email = 'email',
    Name = 'name',
    TrackingVersion = 'tracking_version',
    UserId = 'user_id',
}

export enum DatiqAnalyticsEventTemplateKeys {
    AppRoot = '[APP ROOT]',
}

export enum DatiqAnalyticsPropsPageKeys {
    ApplicationMode = 'application_mode',
    ApplicationVersion = 'application_version',
    CsbUserId = 'csb_user_id',
    BrowserBreakpointSize = 'browser_breakpoint_size',
    BrowserHeight = 'browser_height',
    BrowserLanguage = 'browser_language',
    BrowserUserAgent = 'browser_user_agent',
    BrowserWidth = 'browser_width',
    ScreenHeight = 'screen_height',
    ScreenWidth = 'screen_width',
    DatPrimaryApplication = 'dat_primary_application',
    Email = 'email',
    Initiator = 'initiator',
    Page = 'page',
    TrackingVersion = 'tracking_version',
}

export enum DatiqAnalyticsPropsKeys {
    Origin = 'origin_city_st',
    Destination = 'destination_city_st',
    RecentSearchCount = 'recent_search_count',
    EquipmentType = 'equipment_class',
    RateType = 'rate_type',
    SortColumn = 'sort_column',
    SortDirection = 'sort_direction',
    Timeframe = 'timeframe',
    FuelSurchargeRate = 'fuel_surcharge_rate',
    FuelSurchargeApplied = 'fuel_surcharge_applied',
    FieldName = 'field_name',
    HasData = 'has_data',
    DateSearched = 'date_searched',
    Location = 'location',
    GeoCode = 'geo_code',
    ZoomLevel = 'zoom_level',
    GraphType = 'graph_type',
    DaysFromCurrent = 'days_from_current',
    FilterEquipmentClass = 'filter_equipment_class',
    FilterInOutBound = 'filter_in_out_bound',
    FilterTimeframe = 'filter_timeframe',
    FilterMarketArea = 'filter_market_area',
    FilterLocation = 'filter_location',
    PanelId = 'panel_id',
    FilterTimePeriod = 'filter_timeframe',
    UserClass = 'user_class',
    LeftPanelId = 'left_panel_id',
    RightPanelId = 'right_panel_id',
    LaneId = 'lane_id',
    RfpId = 'rfp_id',
    BenchmarkVersion = 'benchmark_version',
    LMOrigin = 'lm_origin',
    LMDestination = 'lm_destination',
    LMEquipmentType = 'lm_equipment_type',
    BaFilterJson = 'ba_filters_json',
}
